import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { byxSidebar } from '../theme/tokens';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
  // Overline sob o logo, alinhada com o wordmark.
  caption: {
    fontFamily: "'Space Grotesk', 'Open Sans', system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 500,
    letterSpacing: '0.24em',
    textTransform: 'uppercase',
    // The menu group labels' tone, 4.5:1 on the sidebar (X7).
    color: byxSidebar.groupLabel,
    marginTop: 8,
    whiteSpace: 'nowrap',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Início">
        {isOpen ? (
          <div>
            <LogoFull />
            <div className={classes.caption}>backstage</div>
          </div>
        ) : (
          <LogoIcon />
        )}
      </Link>
    </div>
  );
};
